<template>
  <div>
    <v-layout column wrap>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h5 class="font-weight-light">LIST OF BUSINESS OWNER</h5>
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table dense
                      :headers="headers"
                      :items="data_items"
                      :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Data</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                class="mx-2"
                :append-icon="icons.mdiAccountSearch"
                label="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.id }}
              </td>
              <td>
                {{ item.last_name }}
              </td>
              <td>
                {{ item.first_name }}
              </td>
              <td>
                {{ item.middle_name }}
              </td>
              <td>
                {{ item.email_address }}
              </td>
              <td>
                {{ item.contact_no }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
  import {
    mdiAccountGroup
    , mdiAccountSearch
  } from '@mdi/js'
  import {mapActions, mapGetters} from "vuex";

  export default {
    props: {
      data_items: Array,
    },
    data() {
      return {
        icons: {
          mdiAccountGroup,
          mdiAccountSearch,
        },

        search: '',
        headers: [
          {text: 'ID', value: 'id', sortable: true},
          {text: 'Last Name', value: 'last_name', sortable: true},
          {text: 'First Name', value: 'first_name', sortable: true},
          {text: 'Middle Name', value: 'middle_name', sortable: true},
          {text: 'Email', value: 'email_address', sortable: true},
          {text: 'Contact #', value: 'contact_no', sortable: true},
        ],
      }
    },
  }
</script>
